// const API_URL = "http://93.127.206.64:9004";
const API_URL = "https://www.bharatcod.com";

const endPoint = {
  GETALLPRODUCT: `${API_URL}/user/getAllProductsweb`,
  ADDTOCART: `${API_URL}/user/cart/add/web`,
  VIEWCART: `${API_URL}/user/cart/view/web`,
  GETCATEGORY: `${API_URL}/admin/getcategory`,
  REMOVECART: `${API_URL}/user/cart/delete-web`,
  PLACEORDER: `${API_URL}/user/place/website`,
  CHECKOUT: `${API_URL}/user/cart/checkout/web`,
  GETBRANDS: `${API_URL}/users/getBrands`,
  RECENTVIEW: `${API_URL}/user/Viewproducts`,
  GETRECENTVIEW: `${API_URL}/user/recently-viewed/web`,
  ADDWISHLIST: `${API_URL}/user/wishlist/add/web`,
  GETWISHLIST: `${API_URL}/user/wishlist/web`,
  REMOVEWISHLIST: `${API_URL}/users/remove-wishlist`,
  GETSUBCATEGORY: `${API_URL}/user/website/search/subcategory`,
  GETCATEGORYDATA: `${API_URL}/user/website/search/category`,
  RELATEDPRODUCT: `${API_URL}/users/related-product`,
  GETOFFER: `${API_URL}/users/products/flags`,
  GETOFFERNAME: `${API_URL}/users/get-flags`,
  FILTERPRODUCT: `${API_URL}/users/sortProducts/sort`,
  UPDATECART: `${API_URL}/user/cart/update-web`,
  LOGIN: `${API_URL}/user/phone-login/website`,
  SIGNUP: `${API_URL}/users/sign-in`,
  GetProfile: `${API_URL}/users/get-user`,
  TrackOrder: `${API_URL}/users/trac-order-guest`,
  SearchProduct: `${API_URL}/users/search-product`,
  GetReview: `${API_URL}/users/get-reviews`,
  AddReviewUser: `${API_URL}/users/rate-product`,
  ProductSerchById: `${API_URL}/user/view-products`,
  GetBannerApi: `${API_URL}/admin/promotionalImages`,
  GetCouponApi: `${API_URL}/admin/getAll/coupons`,
  ApplyCouponApi: `${API_URL}/users/apply-coupon`,
  SellerLoginApi: `${API_URL}/seller/login-seller`,
  SellerRegister: `${API_URL}/seller/register-seller`,
  SellerAccountApi: `${API_URL}/sellers/seller-account`,
  SellerGstApi: `${API_URL}/sellers/add-gst`,
  SellerPanApi: `${API_URL}/sellers/add-pan`,
  SellerAddressApi: `${API_URL}/sellers/add-address`,
  SellerBankDetails: `${API_URL}/sellers/add-bank`,
  GetBrandWeb: `${API_URL}/user/get-all-brands`,
  GetBrandById: `${API_URL}/user/getProduct-brands`,
  GetFreeGift: `${API_URL}/user/getGiftProduct`,
  GetTrandingProduct: `${API_URL}/user/getTrendingProduct`,
  GetTopSaleProduct: `${API_URL}/user/getTopSaleProducts`,
  SellerForgotPassword: `${API_URL}/seller/forgot-password-seller`,
  SellerResetPassword: `${API_URL}/seller/reset-password-seller`,
  SellerProfile: `${API_URL}/seller/profile-seller`,
  SellerUpdateProfile: `${API_URL}/seller/update-seller`,
  SellerAddProduct: `${API_URL}/seller/add-product`,
  SellerGetProduct: `${API_URL}/seller/my-products`,
  SellerDeleteProduct: `${API_URL}/seller/product`,
  SellerOrder: `${API_URL}/seller/getSellerorders`,
  SellerOrderByIdorStatus: `${API_URL}/seller/search-ordersbyIdorStatus`,
  UpdateOrderStatus: `${API_URL}/seller/updateOrdersStatus`,
  GetSellerWallet: `${API_URL}/seller/get-wallet`,
  SellerWithdraw: `${API_URL}/seller/raise-withdraw-request`,
  getWithdrawRequests: `${API_URL}/seller/withdraw-requests`,
  getAdminWithdrawRequests: `${API_URL}/user/withdraw-requests`,
  approveWithdrawRequest: `${API_URL}/user/update-withdraw-request`,
  GetAllSeller: `${API_URL}/admin/getSeller`,
  SellerWithdrawRequests: `${API_URL}/user/withdraw-requests/seller`,

  ReSellerUpdateProfile: `${API_URL}/reseller/update-reseller`,
  ReSellerProfile: `${API_URL}/reseller/profile-reseller`,
  ResellerLoginApi: `${API_URL}/reseller/login-reseller`,
  ResellerRegister: `${API_URL}/reseller/register-reseller`,
  ResellerResetPassword: `${API_URL}/reseller/reset-password-reseller`,
  ResellerForgotPassword: `${API_URL}/reseller/forgot-password-reseller`,
  ResellerAddProduct: `${API_URL}/reseller/add-product-forresel`,
  GetAllResellerProducts: `${API_URL}/reseller/get-reseller-products`,

  ResellerOrders: `${API_URL}/reseller/get-reseller-order`,
  ResellerWithdrawRequests: `${API_URL}/user/get-reseller-withdrawrequests`,
  approveWithdrawRequestRe: `${API_URL}/user/update-resellerwithdraw-request`,
  ReleaseHoldAmount: `${API_URL}/user/release-resellerhold-amount`,
  ResellerWithdraw: `${API_URL}/reseller/raise-withdraw-request`,
  getWithdrawRequestsRe: `${API_URL}/reseller/get-withdraw-requests`,
  GetResellerWallet: `${API_URL}/reseller/get-wallet`,
  ResellerUpdateOrderStatus: `${API_URL}/reseller/updateOrdersStatus`,
  ResellerOrderByIdorStatus: `${API_URL}/reseller/search-ordersbyIdorStatus`,
};

export default endPoint;
